import React, { useState } from "react";
import {
  Box,
  Grid,
  List,
  ListItem,
  Paper,
  Typography,
  Button,
  Modal
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import useApp from "../../store/contexts/AppContext";

const styleForModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: '#826F6F',
  color: '#fff',
  border: '2px solid #000',
  boxShadow: 24,
  p: 2,
};

export default function JoinRoomTeam({ teams }) {
  const {
    appState: { dataLoading },
    updateARoomTeamByIdApiCall,
  } = useApp();

  const [openModal, setOpenModal] = useState(true);

  const [selectedTeam, setSelectedTeam] = useState(null);

  const handleTeamSelect = (team) => {
    setSelectedTeam(team);
  };

  const handleClearSelection = () => {
    setSelectedTeam(null);
  };

  const handleSubmit = () => {
    updateARoomTeamByIdApiCall({
      roomId: selectedTeam?.room_id,
      teamId: selectedTeam?.id,
    });
  };

  const handleClose = () => {
    // Prevent the modal from being dismissed
    // You can add custom logic here if needed
  };

  return (
    <div>

      <Modal
        open={openModal}
        onClose={handleClose}
        disableEscapeKeyDown
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={styleForModal}>
          <Typography id="transition-modal-title" variant="h6" component="h2" textAlign={'center'}>
            Select a Team
          </Typography>
          <div>
            <Grid item xs={12} md={6}>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <List component="nav">
                  {teams.map((team) => (
                    <ListItem
                      key={team.id}
                      button
                      selected={selectedTeam && selectedTeam.id === team.id}
                      onClick={() => handleTeamSelect(team)}
                    >
                      <Typography variant="h6">{team.name}</Typography>
                      {/* <Typography variant="body2">{team.description}</Typography> */}
                    </ListItem>
                  ))}
                </List>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={!selectedTeam || dataLoading}
                  sx={{ mt: 2 }}
                >
                  Submit{" "}
                  {dataLoading && (
                    <CircularProgress sx={{ color: "white", ml: 2 }} size={24} />
                  )}
                </Button>
              </Paper>
            </Grid>
            {selectedTeam && (
              <div>
                <Box
                  sx={{
                    maxWidth: "500px",
                    margin: "0px auto",
                    p: 2,
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                  }}
                  onClick={handleClearSelection}
                >
                  <Typography variant="h6" sx={{ mb: 1 }}>
                    Selected Team
                  </Typography>
                  <Typography variant="body1">
                    Name: {selectedTeam.name}
                    <br />
                    Description: {selectedTeam.description}
                  </Typography>
                </Box>
              </div>
            )}
          </div>
        </Box>
      </Modal>

    </div>
  );
}
